/**
 * ### useFocus ###
 * It set the focus on the ref, on component mount
 *
 * @param ref A ref to which we will put the focus.
 * @param trigger (optional) Don't do anything if trigger is false
 */
import { MutableRefObject, useEffect } from 'react'

export const useFocus = <T extends MutableRefObject<HTMLElement>>(ref: T, trigger = true): void => {
  useEffect(() => {
    if (ref.current && trigger) {
      ref.current.tabIndex = -1
      ref.current.focus()
    }
  }, [ref, trigger])
}
